import React from "react";
import { View } from "react-native";
import { faExclamationTriangle } from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
import FontAwesomeIcon from "./FontAwesomeIcon";
import Text from "./TextFont";

const MessageBox = (props: any) => {
  // === by default => Warning Mode
  const {
    children,
    shadowColor = Theme.COLORS.ORANGE,
    bgIconColor = "#ff8400db",
    iconColor = Theme.COLORS.WHITE,
    textColor = Theme.COLORS.MUTED,
    icon = faExclamationTriangle,
    renderButton,
  } = props;
  return (
    <View
      style={[
        {
          alignItems: "center",
          marginTop: 58,
          borderRadius: 10,
          paddingTop: 10,
          paddingBottom:5,
          position: "relative",
          backgroundColor: Theme.COLORS.GRAY_LIGHT,

          shadowColor: Theme.COLORS.MUTED,
          shadowOffset: {
            width: 0,
            height: 3,
          },
          shadowOpacity: 0.2,
          shadowRadius: 6.65,
          elevation: 4,
        },
      ]}
    >
      <View
        style={{
          position: "absolute",
          top: -30,
          width: 50,
          height: 50,
          borderRadius: 12,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: bgIconColor,
          shadowColor: shadowColor,
          shadowOffset: {
            width: 0,
            height: 3,
          },
          shadowOpacity: 0.2,
          shadowRadius: 6.65,
          elevation: 4,
        }}
      >
        <FontAwesomeIcon icon={icon} size={26} color={iconColor} />
      </View>
      <Text
        style={{
          textAlign: "center",
          color: textColor,
          fontWeight: "bold",
          fontSize: 16,
          paddingVertical: 20,
          paddingHorizontal: 15,
        }}
      >
        {children}
      </Text>
      <View style={{ width: "100%" }}>{renderButton && renderButton}</View>
    </View>
  );
};

export default MessageBox;
